import { LocaleKey } from 'translations';

export function composeTranslationKey(...args: string[]): LocaleKey {
  /**
   * TODO: Add check with error for the translation key existence
   * */
  const key = args.join('.');
  return key as LocaleKey;
}
